module.exports = [
    {
        "id": "theth",
        "lat": 42.09822241118974,
        "lng": 20.039062500000004,
        "title": "Theth",
        "offset": 1736,
        "image": "http://transasia.mgrubinger.at/wp-content/uploads/2016/09/IMG_3773.jpg"
    }
]



//////////////////
// WEBPACK FOOTER
// ./src/markers.json
// module id = 21
// module chunks = 0